import Section from "../Section";

export default class AnnouncementBar extends Section {

}
